import React from 'react';
import { AVATAR_ICONS } from '../../constants/avatarIcons';
import './avatarIconPicker.css';

interface AvatarIconPickerProps {
  /** value y onChange los inyecta Form.Item de AntD cuando se usa dentro de un form. */
  value?: string | null;
  onChange?: (key: string | null) => void;
  /** Inicial que se muestra en la opción "Sin icono". */
  initial?: string;
  disabled?: boolean;
}

/**
 * Rejilla para elegir icono de avatar. La primera opción siempre es "Sin icono",
 * que muestra la inicial: quitar el icono tiene que ser tan fácil como ponerlo, y
 * si sólo hubiera iconos no habría manera de volver atrás.
 *
 * Vuelve a tocar la misma opción y se deselecciona — el gesto obvio si alguien se
 * arrepiente y no encuentra el "Sin icono".
 */
const AvatarIconPicker: React.FC<AvatarIconPickerProps> = ({
  value,
  onChange,
  initial,
  disabled = false,
}) => (
  <div className="avatar-picker" role="radiogroup" aria-label="Icono de avatar">
    <button
      type="button"
      role="radio"
      aria-checked={!value}
      aria-label="Sin icono, usar la inicial"
      disabled={disabled}
      className={`avatar-picker__option${!value ? ' is-selected' : ''}`}
      onClick={() => onChange?.(null)}
    >
      <span className="avatar-picker__initial">{initial || '—'}</span>
    </button>

    {AVATAR_ICONS.map((option) => (
      <button
        key={option.key}
        type="button"
        role="radio"
        aria-checked={value === option.key}
        aria-label={option.label}
        title={option.label}
        disabled={disabled}
        className={`avatar-picker__option${value === option.key ? ' is-selected' : ''}`}
        onClick={() => onChange?.(value === option.key ? null : option.key)}
      >
        {option.icon}
      </button>
    ))}
  </div>
);

export default AvatarIconPicker;
